class BackToTop {
    constructor() {
        this.class = {
            backToTop: '.js-back-to-top',
            bttTrigger: '.back-to-top__btn',
        };

        this.lastScrollTop = 0;
        this.updateScreenHeights();

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    updateScreenHeights() {
        this.desktopHeight = window.innerHeight;
        this.showAfterScroll = this.desktopHeight * 2; // Two times screen height
        this.minPageHeight = this.desktopHeight * 4; // Four times screen height
    }

    init() {
        this.backToTopEl = document.querySelector(this.class.backToTop);
        this.triggerEl = document.querySelector(this.class.bttTrigger);

        if (!this.backToTopEl || !this.triggerEl) return;

        const pageHeight = document.documentElement.scrollHeight;

        // activate only if the page is at least four times the screen height
        if (pageHeight < this.minPageHeight) return;

        this.calcHeight();
        window.addEventListener('resize', this.handleResize.bind(this));
        window.addEventListener('scroll', this.handleScroll.bind(this));
        this.initScrolling();
    }

    // updates values when the window is resized
    handleResize() {
        this.updateScreenHeights();
        this.calcHeight();
    }

    // controls when the button appears/disappears based on scrolling
    handleScroll() {
        const currentScroll = window.scrollY;

        if (currentScroll > this.showAfterScroll && currentScroll > this.lastScrollTop) {
            // show button when at least 2 times the screen height has been scrolled and scrolling down
            this.triggerEl.classList.add('back-to-top__btn--visible');
        } else if (currentScroll <= 0) {
            // hide button when reaching the top
            this.triggerEl.classList.remove('back-to-top__btn--visible');
        }

        this.lastScrollTop = currentScroll;
    }

    // adjusts the button’s position dynamically
    calcHeight() {
        const offset = this.backToTopEl.getBoundingClientRect().top + document.documentElement.scrollTop;
        this.backToTopEl.style.setProperty('--offset', `${offset}px`);
    }

    // enables smooth scrolling to the top when clicking the button
    initScrolling() {
        this.triggerEl.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }
}

new BackToTop();
